export default ({router,store}) => (routes,cb)=>{
    let permissionTags = store.state.main.user.permissionTags
    let routerArr = []
    console.log('处理前的路由',routerArr)
    dp(routes)
    console.log('处理的路由',routerArr)
    router.addRoutes(routerArr)
    function dp(obj){
        for(let i in obj){
            let {meta} = obj[i]
            if(meta.noDeep){
                console.log('nodeep',obj[i])
            }
            let canAdd = false
            if(meta){
                if(meta.permissionTag&&permissionTags.indexOf(meta.permissionTag) > -1){
                    canAdd = true
                }else if(!meta.permissionTag){
                    canAdd = true
                }
            }else{
                canAdd = true
            }
            if(canAdd){
                let routeItem = {
                    ...obj[i]
                }
                if(!routeItem.meta||routeItem.meta&&!routeItem.meta.noDeep){
                    routeItem.children = []
                }else if(routeItem.meta&&routeItem.meta.noDeep){
                    filterPer(routeItem)
                }
                routerArr.push(routeItem)
            }
            if((obj[i].meta||obj[i].meta&&!obj[i].meta.noDeep)&&obj[i].children&&obj[i].children.length){
                dp(obj[i].children)
            }
        }
    }
    function filterPer(obj){
        if(obj.children&&obj.children.length){
            let childs = obj.children
            for(var i = 0;i<childs.length;i++){
                if(childs[i].meta){
                    if(childs[i].meta.permissionTag&&permissionTags.indexOf(childs[i].meta.permissionTag) == -1){
                        childs.splice(i,1)
                        i--
                    }
                }
                if(childs[i]&&childs[i].children&&childs[i].children.length){
                    filterPer(childs[i])
                }
            }
        }
    }
}